import React, { useCallback, useEffect, useState } from "react";
import { AppDispatch } from "../../..";
import { InvitationProject } from "../../../reducers/data";
import { GetProject } from "../../../api/projectapi";

type Props = {
  __cancel: () => void;
  content: any;
  dispatch: AppDispatch;
};

function ProjectChoice({ __cancel, content, dispatch }: Props) {
  const [search, setsearch] = useState<string>("");
  const [project, setProject] = useState<any[]>([]);
  const [data, setData] = useState(project);

  const __searchInit = useCallback(() => {
    if (search) {
      const clone = project.slice();
      setData(clone.filter(({ title }) => title.includes(search)));
    } else {
      setData(project);
    }
  }, [search]);

  const __updateProject = useCallback(
    (id: string, title: string) => {
      dispatch(
        InvitationProject({
          id,
          title,
        })
      );
      __cancel();
    },
    [dispatch, __cancel]
  );
  useEffect(() => {
    GetProject("prjt", `&leadr_usr_id=${content.id}`, "", undefined).then(
      ({ state, data }) => {
        if (state) {
          setProject(data);
          setData(data);
        }
      }
    );

    return () => {};
  }, [content]);

  return (
    <div className="project-popup">
      <div className="wrapper">
        <div className="title">{content.name}님의 프로젝트</div>
        <form
          className="input-box"
          onSubmit={(e) => {
            __searchInit();
            e.preventDefault();
          }}
        >
          <div className="left">
            <input
              type="text"
              placeholder="프로젝트 검색"
              className="input"
              onChange={(e) => {
                setsearch(e.target.value);
              }}
            ></input>
            <img
              className="search"
              src="/assets/common/search.svg"
              onClick={__searchInit}
              alt=""
            />
          </div>
        </form>
        <div className="name-box">
          <div className="title1">프로젝트명</div>
        </div>
        <div className="list">
          {data.map(({ prjt_id, prjt_nm }, index) => {
            return (
              <div
                key={index}
                className="box"
                onClick={() => {
                  __updateProject(prjt_id, prjt_nm);
                }}
              >
                <div className="name">{prjt_nm}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default ProjectChoice;
